function deepClone<T>(value: T): T
{
	return JSON.parse(JSON.stringify(value));
}

export default deepClone;
